import { checkIfHasUnreadNotification, fetchUnreadNotificationCount } from '@/api/notification';
import { getPendingAssignmentCount } from '@/api/bookings';
import { fetchUnreadBookingCount } from '@/api/bookings';

export async function reCheckIfHasUnreadNotification(store, $axios) {
  store.commit('notification/setHasUnreadNotification', await checkIfHasUnreadNotification($axios));
}

export async function syncPendingAssignmentAppointmentCount(store, api) {
  store.commit(
    'notification/setPendingAssignmentAppointmentCount',
    await getPendingAssignmentCount(api),
  );
}

export async function syncClinicUnreadBookingCount(store, api) {
  store.commit('booking/setUnreadCount', await fetchUnreadBookingCount(api));
}

export async function syncClinicUnreadNotificationCount(store, api) {
  store.commit('notification/setUnreadCount', await fetchUnreadNotificationCount(api));
}
